import { QueryClient, queryOptions, skipToken, UseQueryOptions } from "@tanstack/react-query";
import { Build, Job } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";
import { useBuildPageStore } from "~/components/build/Show/lib/useBuildPageStore";

export const jobQueryKey = (buildId: Build["id"], jobId: Job["id"]) => {
  return ["build", buildId, "jobs", jobId];
};

export const jobQueryOptions = (
  build: Build,
  jobId: Job["id"] | undefined | null,
  queryOptionsArgs: Omit<UseQueryOptions<Job>, "queryKey" | "queryFn"> = {},
) => {
  const { enabled: callerEnabled, ...restOptions } = queryOptionsArgs;
  const enabled = !!jobId && (callerEnabled ?? true);

  return queryOptions({
    queryKey: jobQueryKey(build.id, jobId ?? ""),
    queryFn: enabled
      ? ({ signal }) =>
          fetchJob(build.buildDataBasePath, jobId, signal).then((job) => {
            useBuildPageStore.getState().setJobs([job]);
            return job;
          })
      : skipToken,
    enabled,
    ...restOptions,
  });
};

export const setJobQueryData = (buildId: Build["id"], job: Job, queryClient: QueryClient) => {
  queryClient.setQueryData(jobQueryKey(buildId, job.id), job);
};

async function fetchJob(
  buildDataBasePath: Build["buildDataBasePath"],
  jobId: Job["id"],
  signal: AbortSignal,
): Promise<Job> {
  const url = new URL(`${buildDataBasePath}/jobs`, window.location.origin);
  url.searchParams.set("uuid", jobId);

  const response = await fetcher<{ records: Job[] }>(url, true, { signal });
  const job = response.records[0];

  if (!job) {
    throw new Error("Job does not exist");
  }

  return job;
}
